var SENTRY_RELEASE;SENTRY_RELEASE={name: "Grove", version: "1.0.0"};